<template>
  <div>
    <v-card outlined class="rounded-card">
      <v-subheader class="font-weight-bold text--primary">Produtos</v-subheader>
      <v-divider/>
      <v-list class="rounded-card">
        <template v-for="(produto, index) in produtos">
          <v-list-item :key="produto.id">
            <v-list-item-content>
              <v-row dense>
                <v-col cols="12" class="body-1">
                  <px-produto-descricao
                    :show-descricao-with-tooltip="false"
                    :especificacao="produto.especificacaoProduto"
                    :produto="produto.produto"/>
                  <span>
                    ({{produto.quantidade
                      | number(getCurrencyFormat(produto.produto.casasDecimais)) }}
                     {{produto.unidadeMedida.descricao}})
                  </span>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="4">
                  <span class="caption font-weight-bold">Código de referência do fornecedor</span>
                  <div>
                    {{ codigoReferencia(produto.produto.fornecedoresProduto) | naoInformado }}
                  </div>
                </v-col>
                <v-col cols="12" sm="4">
                  <span class="caption font-weight-bold">Especificacao</span>
                  <div>
                    <px-show-large-text :large-text="produto.especificacaoProduto"/>
                  </div>
                </v-col>
                <v-col cols="12" sm="4">
                  <span class="caption font-weight-bold">Observação externa do produto</span>
                  <div>
                    <px-show-large-text :large-text="observacaoExterna(produto)"/>
                  </div>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="4">
                  <span class="caption font-weight-bold">Finalidade da compra</span>
                  <div v-if="produto.finalidadeCompra">
                    <px-finalidade-compra-value :finalidade-compra="produto.finalidadeCompra"/>
                  </div>
                  <div v-else>
                    Não informado
                  </div>
                </v-col>
                <v-col cols="12" sm="4">
                  <span class="caption font-weight-bold">Prazo de entrega</span>
                  <div>
                    {{ produto.dataPrevisaoEntrega | date | naoInformado }}
                  </div>
                </v-col>
                <v-col cols="12" sm="4">
                  <span class="caption font-weight-bold">Anexos</span>
                  <div v-if="produto.arquivos.length">
                    <px-anexo-chip :files="produto.arquivos"
                                   :download-base-path="downloadBasePath"/>
                  </div>
                  <div v-else>
                    Nenhum anexo informado
                  </div>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
          <v-divider v-if="index !== (produtos.length - 1)"
                     :key="`v-div${produto.id}`"/>
        </template>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import { CasaDecimalUtils, FornecedorProdutoUtils } from 'px-components';

export default {
  props: {
    produtos: Array,
    idFornecedor: [String, Number],
    idSolicitacao: [String, Number],
  },
  computed: {
    downloadBasePath() {
      return `external/solicitacao/${this.idSolicitacao}/file`;
    },
    getCurrencyFormat() {
      return item => CasaDecimalUtils.getCurrencyFormat(item);
    },
    observacaoExterna() {
      return produto => produto.observacaoExterna ?? produto.produto.observacaoExterna;
    },
    codigoReferencia() {
      return fornecedoresProduto => FornecedorProdutoUtils.getCodigoReferenciaFornecedor(
        fornecedoresProduto,
        this.idFornecedor,
      );
    },
  },
};
</script>
